import { Col, colors, ContainerV2, maxWidth, Row } from 'hui';
import React from 'react';
import styled from 'styled-components';
import { HeaderContextProvider, loginDataShape } from './HeaderContext';
import { logo } from './presentational/left';
import HeaderActions from './presentational/right/header-actions';
import HeaderLoggedIn from './presentational/right/header-loggedin';

export const Logo = styled.a`
  display: block;
  height: 30px;
  width: 80px;
  flex: 0 0 80px;
  background: url(${logo}) no-repeat;
  background-size: contain;
`;

const Right = styled.div`
  justify-self: flex-end;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  ${maxWidth('sm')} {
    display: none;
  }
`;

type HeaderSimpleShape = {
  loginData: loginDataShape;
};

const Background = styled.div`
  padding: 1rem 0;
  background-color: ${colors.tint6};
`;

const HeaderSimple: React.FC<HeaderSimpleShape> = ({ loginData }) => {
  const siteSource = 'Header Simple';
  return (
    <HeaderContextProvider
      hasSearch={false}
      siteSource={'HeaderSimple'}
      loginData={loginData}
      shouldShowActions={true}
    >
      <Background>
        <ContainerV2>
          <Row>
            <Col md={4} xs={4}>
              <Logo
                href="/"
                data-ga-category={siteSource}
                data-ga-action={`${siteSource} - Clicked Home`}
                data-ga-label={`${siteSource} - Clicked Home`}
              />
            </Col>
            <Col md={8} xs={8}>
              <Right>
                <HeaderActions />
                {loginData.logged_in && <HeaderLoggedIn />}
              </Right>
            </Col>
          </Row>
        </ContainerV2>
      </Background>
    </HeaderContextProvider>
  );
};

export default HeaderSimple;
